import { insertPlaqueAndAlertWindow } from "/alert/alert_functions.js";
import { API_UPLOAD_URL } from '/constants/API_constants.js';
import { createFileChecker } from '/misc_functions/file_management.js';
import { createRequestObject } from '/request/request.js';

const methodReadValues = {
    'YT_URL' : youtubePreviewCreate,
    'SCL_URL' : soundcloudPreviewCreate,
    'PIC_FILE' : picFilePreviewCreate,
    'IDEA' : ideaPreviewCreate
}

export function createPreviewPromise(previewMethod, contentPreviewSection, injectionsObject) {
    console.log("previewMethod "+previewMethod);
    
    const previewPromiseFunction = methodReadValues[previewMethod];

    if(previewPromiseFunction instanceof Function)
        return previewPromiseFunction(contentPreviewSection, injectionsObject);
    else
        return Promise.reject(new Error("Invalid preview creation method."));
}

function youtubePreviewCreate(contentPreviewSection) {
    
    const url = contentPreviewSection.querySelector('iframe').src;

    const videoId = url.replace("https://www.youtube.com/embed/", "").replace("?feature=oembed", "");

    const preview = {
        method: 'YT_URL',
        videoId: videoId
    }

    return Promise.resolve(preview);
}

function soundcloudPreviewCreate(contentPreviewSection) {
    
    const url = contentPreviewSection.querySelector('iframe').src;

    // Extract the encoded "url" parameter
    const params = new URLSearchParams(url.split('?')[1]);
    const encodedTrackUrl = params.get('url'); // e.g. "https%3A%2F%2Fapi.soundcloud.com%2Ftracks%2F1946207687"

    if (!encodedTrackUrl)
        throw new Error("Invalid SoundCloud embed URL — missing track parameter.");

    // Decode the parameter
    const decodedTrackUrl = decodeURIComponent(encodedTrackUrl); // e.g. "https://api.soundcloud.com/tracks/1946207687"

    // Extract just the track ID
    const trackId = decodedTrackUrl.split('/').pop(); // "1946207687"

    const preview = {
        method: 'SCL_URL',
        trackId: trackId
    }

    return Promise.resolve(preview);
}

function picFilePreviewCreate(contentPreviewSection, injectionsObject) {
    let outerResolvePromise;
    let outerRejectPromise;
    const previewPromise = new Promise((resolve, reject) => {
        outerResolvePromise = resolve;
        outerRejectPromise = reject;
    });
    const file = contentPreviewSection.querySelector('input').files[0];

    const onResponseStatus4xxFunction = () => {
        injectionsObject.onResponseStatus4xxFunction
        outerRejectPromise(new Error('Promise rejected while doing a file upload.'));
    };
    const somethingWentWrong = () => {
        injectionsObject.somethingWentWrong
        outerRejectPromise(new Error('Promise rejected while doing a file upload.'));
    };
    const loadingScreen = injectionsObject.loadingScreen;
    const buttonSection = injectionsObject.buttonSection;


    const uploadTokenRequest = createRequestObject();
    uploadTokenRequest.setMethod('POST');
    uploadTokenRequest.setURL('/branches/submit/upload/get-token');

    const fileChecker = createFileChecker();
    fileChecker.setFilePurpose('branch_picture');
    fileChecker.setUniversalStatus((message) => {
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        insertPlaqueAndAlertWindow(message);
        outerRejectPromise(new Error('Promise rejected while doing a file upload.'));
    });

    const fileValid = fileChecker.checkFile(file);

    if(fileValid===false)
        return;

    const uploadFielRequest = createRequestObject();
    uploadFielRequest.setRootURL(API_UPLOAD_URL);
    uploadFielRequest.setURL('/branches/picture');
    uploadFielRequest.setMethod('POST');
    const formData = new FormData();
    formData.append('file', file);
    uploadFielRequest.setBodyFormData(formData);

    uploadTokenRequest.onResponseStatus('200', async (response) => {
        const uploadToken = await response.text();
        console.log("uploadToken ", uploadToken);

        return uploadToken;
    });
    uploadTokenRequest.onResponseStatus4xx(onResponseStatus4xxFunction);
    uploadTokenRequest.onResponseElse(somethingWentWrong);

    uploadFielRequest.onResponseStatus('200', async (response) => {
        const key = response.text();
        
        return key;
    });
    uploadFielRequest.onResponseStatus4xx(onResponseStatus4xxFunction);
    uploadFielRequest.onResponseError(() => {
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        insertPlaqueAndAlertWindow('We see what you\'re trying to do here.');
        outerRejectPromise(new Error('We see what you\'re trying to do here.'));
    });
    uploadFielRequest.onResponseElse(async (response) => {
        loadingScreen.remove();
        buttonSection.classList.remove('hidden-info');
        insertPlaqueAndAlertWindow('An error occured.');

        const errorText = await response.text();
        console.log("uploadFielRequest error ", errorText);
        outerRejectPromise(new Error(errorText));
        
    });

    uploadTokenRequest
    .executeRequest()
    .then(uploadToken => {
        uploadFielRequest.addHeader('upload-token', uploadToken);
        return uploadFielRequest.executeRequest();
    })
    .then(key => {
        const preview = {
            method : 'PIC_FILE',
            key : key
        };

        outerResolvePromise(preview);
    });

    return previewPromise;
}

function ideaPreviewCreate() {
    const preview = {
        method : 'IDEA'
    };

    return Promise.resolve(preview);
}